var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhiteAudio(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.51 15.38C19.28 15.38 18.09 15.18 16.98 14.82C16.63 14.7 16.24 14.79 15.97 15.06L14.4 17.03C11.57 15.68 8.92 13.13 7.51 10.2L9.46 8.54C9.73 8.26 9.81 7.87 9.7 7.52C9.33 6.41 9.14 5.22 9.14 3.99C9.14 3.45 8.69 3 8.15 3H4.69C4.15 3 3.5 3.24 3.5 3.99C3.5 13.28 11.23 21 20.51 21C21.22 21 21.5 20.37 21.5 19.82V16.37C21.5 15.83 21.05 15.38 20.51 15.38Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteAudio);
export default __webpack_public_path__ + "static/media/white-audio.ea3723de99f17dfbb002b474c6b3c7b8.svg";
export { ForwardRef as ReactComponent };